import React from 'react';
import { Home, RotateCcw } from 'lucide-react';

interface ApartmentEmptyStateProps {
  onReset: () => void;
}

export default function ApartmentEmptyState({ onReset }: ApartmentEmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-24 text-center">
      <div className="w-20 h-20 rounded-3xl bg-secondary flex items-center justify-center mb-6">
        <Home size={36} className="text-primary" />
      </div>
      <h3 className="text-xl font-bold text-foreground mb-2">No apartments match your filters</h3>
      <p className="text-muted-foreground max-w-sm mb-6">
        Try adjusting your search criteria — remove some filters or expand your price range to see more options.
      </p>
      <button onClick={onReset} className="btn-primary gap-2">
        <RotateCcw size={15} />
        Reset All Filters
      </button>
    </div>
  );
}